import React, { useEffect, useRef, useState } from 'react';
import type { PubSubServiceV1, PubSubTopicV1 } from '@smart/pub-sub-service';
import classnames from 'classnames';
import type { ButtonProps } from '../button';
import { Button } from '../button';
import styles from './popup-container.module.scss';
import { useOutsideClick } from '../../hooks';

export type PopupContainerProps = {
  children: React.ReactNode;
  subscribeFunc: PubSubServiceV1['subscribe'];
  topic: PubSubTopicV1;
  closeButtonStyles?: ButtonProps['className'];
};
export const PopupContainer: React.FC<PopupContainerProps> = ({
  children,
  subscribeFunc,
  topic,
  closeButtonStyles
}) => {
  const [showPopup, setShowPopup] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const unsubscribe = useRef<ReturnType<typeof subscribeFunc> | null>(null);

  const handleClose = () => {
    setShowPopup(false);
  };

  useOutsideClick(ref, handleClose);

  useEffect(() => {
    if (showPopup) {
      document.body.classList.add(`no-scroll`);
    } else {
      document.body.classList.remove(`no-scroll`);
    }
    unsubscribe.current = subscribeFunc(topic, () => setShowPopup(true));
    return () => {
      document.body.classList.remove(`no-scroll`);
      if (unsubscribe.current) unsubscribe.current();
    };
  }, [showPopup, topic, subscribeFunc]);
  return (
    <>
      <div className={classnames(styles.overlay, { [styles.visible]: showPopup })} />
      <div className={classnames(styles.popup, { [styles.visible]: showPopup })} ref={ref}>
        <Button
          variant={`ghost`}
          iconName={`close-without-circle--medium`}
          size={`300`}
          ariaLabel={`close`}
          className={closeButtonStyles ?? styles['overlay__popupCloseButton']}
          onClick={() => handleClose()}
        />
        {children}
      </div>
    </>
  );
};
